import {FC} from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper/Paper';

import {AddContractForm} from './AddContractForm';

const AddContract: FC = () => {
  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '70%', margin: '0 auto', mt: 4, mb: 4, p: '8px 16px 16px 16px'}}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Typography sx={{flex: '1 1 100%'}} variant="h6" id="formTitle" component="div">
            Новый контракт
          </Typography>
        </Toolbar>
        <AddContractForm />
      </Paper>
    </Box>
  );
};

export default AddContract;
